var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.6665,
    y: 14.666,
    width: 4,
    height: 9.33333,
    rx: 1,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 15.3327L14.5585 8.68108C14.8058 8.11224 15.4554 7.83686 16.0362 8.05466C17.0031 8.41722 17.616 9.37278 17.5425 10.4027L17.3656 12.8785C17.3481 13.1239 17.5424 13.3327 17.7885 13.3327H21.9233C23.1756 13.3327 24.1198 14.4704 23.8891 15.7013L22.843 21.2803C22.5474 22.8569 21.1708 23.9993 19.5667 23.9993H12.6665C12.1142 23.9993 11.6665 23.5516 11.6665 22.9993V15.3327Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb-up.4c36c172eb4706ce165ca759200d79c1.svg";
export { ForwardRef as ReactComponent };